import useMedia from 'hooks/use-media'
import Image from 'next/image'
import LogoSrc from '../../../public/images/logo/Logo-JTS-Final-min.png'

const Logo = ({isCustom = false, customWidth = 60, customHeight = 60}) => {
    const isSm = useMedia('(max-width: 1023px)')
    const isLg = useMedia('(min-width: 1024px)')
    const isXl = useMedia('(min-width: 1440px)')
    let width = !isSm ? 200 : 110
    let height = !isSm ? 90 : 50 
    if (isCustom) {
        width = customWidth
        height = customHeight
    } else {
        if (isLg) {
            width = 150
            height = 68
        }
        if (isXl) {
            width = 200
            height = 90
        }
    }
    const attributes = { 
        width, 
        height, 
        src: LogoSrc, 
        alt: 'JTS-Brand',
        loading: 'eager' 
    } 
    return <>
        <Image {...attributes}/>
    </>
}

export default Logo